import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import moment from 'moment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs';

export class MomentDateHttpInterceptor implements HttpInterceptor {
    iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;
    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            tap((event: HttpEvent<unknown>) => {
                if (event instanceof HttpResponse) {
                    const body = event.body;
                    this.convertToDate(body);
                }
            }),
        );
    }

    convertToDate(body): void {
        if (typeof body === 'object' && body !== null) {
            const casted = body as { [key: string]: any };
            for (const key of Object.keys(casted)) {
                const value = casted[key];
                if (this.isIso8601(value)) {
                    casted[key] = moment.utc(value);
                } else if (typeof value === 'object' && value !== null) {
                    this.convertToDate(value);
                }
            }
        } else {
            return body;
        }
    }

    isIso8601(value: unknown): value is string {
        return typeof value === 'string' ? this.iso8601.test(value) : false;
    }
}